<template>
  <button
   class="button pa-fetch-button pa-fetch-button-park-note-comment-view"
   :class="additionalClass"
   :disabled="isDisabled"
   
   @click.prevent="handleClick"
  >前のコメントを読み込む</button>
</template>

<script>
export default {
  props : {
    isLoading : {
      default : false
    }
  },

  data(){
    return {
      additionalClass : {
        'is-loading'  : false
      },

      isDisabled      : false,

      page            : null,
      lastPage        : null,
      total           : null,
    };
  },
  
  computed : {
    parkNoteId(){
      return this.$store.state.parkNoteComment.parkNoteId;
    },

    storedParkNoteComments(){
      return this.$store.state.parkNoteComment.parkNoteComments;
    }
  },

  watch : {
    page : {
      handler(){
        this.checkLastPage();
      },
      immediate: true
    },

    storedParkNoteComments : {
      handler(){
        this.setParkNoteCommentListData();
      },
      immediate: true,
      deep:true
    },

    parkNoteId  : {
      handler(){
        this.setParkNoteCommentListData();
      },
      immediate: true
    },

    isLoading : {
      handler(value){
        if(value === true){
          this.isDisabled = true;
          this.additionalClass['is-loading'] = true;
        }else{
          this.isDisabled = false;
          this.additionalClass['is-loading'] = false;
        }

        this.checkLastPage();
      },
      immediate: true
    }
  },

  methods : {
    checkLastPage(){
      if(this.page === null) return;
      if(this.lastPage === null) return;
      
      if(this.page === this.lastPage){
        this.isDisabled = true;
      }
    },

    handleClick(){
      this.$emit('handleClick');
    },

    setParkNoteCommentListData(){
      if(this.parkNoteId === null) return;

      for(let i = 0; i < this.storedParkNoteComments.length; i++){
        if(this.storedParkNoteComments[i].parkNoteId === this.parkNoteId){
          this.page         = this.storedParkNoteComments[i].page;
          this.lastPage     = this.storedParkNoteComments[i].lastPage;
          this.total        = this.storedParkNoteComments[i].total;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-fetch-button{
  &-park-note-comment-view{
    display:block;
    border:2px solid #C4A37D;
    background-color: #C4A37D;
    color: #7D5940;
    padding:0;

    width:100%;
    margin:0 auto 1rem;

    &:hover, &:active, &:focus{
      color: #7D5940;
      border-color: #C4A37D;
      box-shadow:none;
    }

    &.is-loading, &:disabled{
      background-color: #B9916F;
      border-color: #B58A68;
    }

    &.is-loading::after{
      border: 1.3px solid #6C482B;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    @include from($tablet) {
      width:96%;
      margin:1rem auto 1rem;
    }
  }
}
</style>